import { extractError, extractErrorFromSap } from '../service/response.service'
import { api } from '../service/api.service'
import { extendObservable, autorun } from 'mobx'
import t from '../service/translate.service'
import User from '../store/user.store'
import ContractStore from './contract.store'
import {
  buildValidators,
  requiredCheckbox
} from '../service/validate'
class LoyaltyStore {
  constructor() {
    extendObservable(this, {
      user: User.user,
      userRegistered: false,
      userQueuedUp: false,
      model: {
        contractNumber: '',
        terms: false
      },
      pointsList: {
        totalPoints: 0,
        rows: []
      },
      errorListVoice: false,
      errorsList: [],
      contractSelected: false,
      errorTitle: '',
      error: '',
      unregisterError: '',
      accountError: '',
      loyaltyProgramView: {},
      submitted: false,
      loading: false,
      showSuccessMessage: true,
      files: [],
      uploaded: false,
      uploadError: '',
      previewImage: false,
      code: '',
      redeemCode: false,
      codeUploaded: false,
      codeUploadError: '',
      pointsAwarded: null,
      loyaltyPayment: false,
      cashOut: false,
      deposit: false,
      keepPoints: false,
      iban: '',
      confirmIban: false,
      email: '',
      password: '',
      createdAt: '',
      pointsToEuro: 0,
      showThankYou: false,
      cashOutError: '',
      contractVerified: false,
      contractCardBlur: false
    })

    this.submitRedeemCode = this.submitRedeemCode.bind(this)
    this.redeemPoints = this.redeemPoints.bind(this)
    this.registerUserForLoyalty = this.registerUserForLoyalty.bind(this)
    this.getLoyaltyProgramViewData = this.getLoyaltyProgramViewData.bind(this)
    this.getRegistrationDate = this.getRegistrationDate.bind(this)
    this.checkContract = this.checkContract.bind(this)
    this.unregisterFromLoyaltyProgram = this.unregisterFromLoyaltyProgram.bind(this)
    this.submitImage = this.submitImage.bind(this)
    this.addFile = this.addFile.bind(this)
    this.setCode = this.setCode.bind(this)
    this.setVal = this.setVal.bind(this)
    this.setIban = this.setIban.bind(this)
    this.setEmail = this.setEmail.bind(this)
    this.setPassword = this.setPassword.bind(this)
    this.toggleConfirmIban = this.toggleConfirmIban.bind(this)
    this.toggleShowAll = this.toggleShowAll.bind(this)
    this.contractSelect = this.contractSelect.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    autorun(() => {
      if (this.user.registeredToLoyaltyProgram && this.user.loyaltySerialNumber) {
        this.userRegistered = this.user.registeredToLoyaltyProgram
        this.getLoyaltyProgramViewData(this.user.loyaltySerialNumber)
        this.checkContractVerification(this.model.contractNumber)
      }
    })
  }

  get alertValidators() {
    return buildValidators(
      {
        terms: [requiredCheckbox]
      },
      true
    )
  }

  get validators() {
    return buildValidators(
      {
        terms: [requiredCheckbox]
      },
      this.submitted
    )
  }

  setCode = (value) => {
    this.code = value
    this.codeUploadError = value ? '' : t.LOYALTY_CODE_EMPTY
  }
  setVal = (field, value) => {
    this.errorListVoice = false
    this.model[field] = value
  }

  setIban = (value) => {
    this.iban = value
  }

  setEmail = (value) => {
    this.email = value
  }

  setPassword = (value) => {
    this.password = value
  }

  toggleConfirmIban = () => {
    this.confirmIban = !this.confirmIban
  }

  toggleShowAll = () => {
    this.pointsList.rows = this.loyaltyProgramView.account_lines
  }

  contractSelect = (contractNumber) => {
    this.errorListVoice = false
    this.setVal('contractNumber', contractNumber)
    this.contractSelected = false
    this.contractCardBlur = false
    this.contractInUse = false
  }

  onSubmit = (e) => {
    this.submitted = false
    this.errorListVoice = true
    this.errorsList = []

    e.preventDefault()
    this.submitted = true
    if (!this.model.contractNumber) {
      this.errorsList.push({err: `${t.NO_CONTRACT_SELECTED_ERROR}`, index: 0})
    }
    if (!this.model.terms) {
      this.errorsList.push({err: `${t.TERMS_AND_CONDITIONS_REQUIRED}`, index: 1})
    }
    if (!this.model.contractNumber) {
      this.contractSelected = true
    } else {
      if (!this.model.terms) {
        return
      }
      this.checkContract(this.model.contractNumber)
    }
  }

  async checkContract(contractNumber) {
    this.loading = true
    this.error = ''
    try {
      const res = await api.get(`/loyalty/${contractNumber}/check`)
      if (!res.data.inUse) {
        this.registerUserForLoyalty(contractNumber)
      } else {
        this.error = t.CONTRACT_ALREADY_IN_USE
        this.errorTitle = t.CONTRACT_ALREADY_IN_USE_TITLE
        this.loading = false
        window.scrollTo(0, 0)
      }
    } catch (err) {
      this.error = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      this.loading = false
      window.scrollTo(0, 0)
    }
  }

  async getLoyaltyProgramViewData(loyaltySerialNumber) {
    this.loading = true
    try {
      const res = await api.get(`/loyalty/${loyaltySerialNumber}/account`)
      const contract = this.user.contracts.find((c) => c.contractNumber.includes(res.data.contract))
      if(contract) {
        this.model.contractNumber = contract.contractNumber
        this.getRegistrationDate(this.model.contractNumber)
        this.loyaltyProgramView = res.data
        this.pointsList.totalPoints = res.data.total_points
        this.pointsList.rows = res.data.account_lines
        this.loading = false
        this.pointsToEuro = res.data.total_points / 120
      } else {
        this.accountError = t['SOMETHING_WENT_WRONG']
        this.errorTitle = t['SOMETHING_WENT_WRONG']
        this.loading = false
      }
    } catch (err) {
      console.log(extractError(err))
      this.accountError = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      this.errorTitle = t[extractError(err) + '_TITLE']
      this.loading = false
      window.scrollTo(0, 0)
    }
  }

  async checkContractVerification(contract) {
    const contractStore = new ContractStore()
    const res = await contractStore.getContractVerificationInfo(contract)
    if(res) this.contractVerified = true
  }

  async registerUserForLoyalty(contractNumber, serialNumber) {
    try {
      this.error = ''
      const res = await api.post(`/loyalty/register`, { contractNumber, serialNumber })
      this.userRegistered = true
      this.user.registeredToLoyaltyProgram = true
      this.user.loyaltySerialNumber = res.data.loyaltySerialNumber
      this.getLoyaltyProgramViewData(res.data.loyaltySerialNumber)
    } catch (err) {
      console.log(extractError(err))
      this.error = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      this.errorTitle = t[extractError(err) + '_TITLE']
      this.loading = false
      window.scrollTo(0, 0)
    }
  }

  async unregisterFromLoyaltyProgram() {
    this.loading = true
    try {
      await api.put(`/loyalty/${this.user.loyaltySerialNumber}/unregister`)
      this.model.contractNumber = ''
      this.model.terms = false
      this.user.registeredToLoyaltyProgram = false
      this.userRegistered = false
      this.submitted = false
      this.loading = false
      this.user.loyaltySerialNumber = ''
    } catch (err) {
      console.log(extractError(err))
      this.unregisterError = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      this.errorTitle = t[extractError(err) + '_TITLE']
      this.loading = false
      window.scrollTo(0, 0)
    }
  }

  addFile(files) {
    this.uploadError = ''
    files.forEach(file => this.files.push(file))
    this.previewImage = true
  }

  async submitImage(type) {
    this.loading = true

    try {
      var formData = new FormData()
      formData.append('contractNumber', this.model.contractNumber)
      formData.append('file_0', this.files[0], this.files[0].name)
      const req = await api
        .post('/user-files/' + type, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      this.files = []
      this.loading = false
      this.uploadError = ''
      this.uploaded = true
      this.previewImage = false
      window.scrollTo(0, 0)
      return req
    } catch (err) {
      this.loading = false
      this.files = err.crossDomain ? [] : this.files
      this.uploadError = err.crossDomain ? t.LOYALTY_EXTERNAL_FILE_ERROR : t[extractError(err)] || t['ERROR']
      this.previewImage = !err.crossDomain
    }
  }

  async submitRedeemCode(e) {
    e.preventDefault()
    this.loading = true
    if (!this.code) {
      this.codeUploadError = t.LOYALTY_CODE_EMPTY
      this.loading = false
    } else {
      const formData = new FormData()
      formData.append('serialNumber', this.user.loyaltySerialNumber)
      formData.append('couponCode', this.code)
      try {
        const req = await api
          .post('/loyalty/redeem-code', formData, { headers: {
            'Content-Type': 'multipart/form-data'}
          })
        this.pointsAwarded = req.data.points
        this.codeUploadError = ''
        this.code = ''
        this.codeUploaded = true
        this.redeemCode = false
        this.getLoyaltyProgramViewData(this.user.loyaltySerialNumber)
      } catch (err) {
        const error = extractError(err)
        this.loading = false
        let STATUS
         if(error === 'LIMIT_EXCEEDED') STATUS = 'LIMIT_EXCEEDED'
         else
         switch (error.message) {
          case 'Code already redeemed.':
            STATUS = 'ALREADY_REDEEMED'
            break
          case 'Code nicht mehr gültig':
            STATUS = 'ALREADY_REDEEMED'
            break
          case 'Code nicht vorhanden':
            STATUS = 'NOT_ACCEPTABLE'
            break
          default:
            STATUS = 'NOT_FOUND'
        }
        if (STATUS) {
          this.codeUploadError = extractErrorFromSap(err) || t['LOYALTY_CODE_ERROR_' + STATUS] || t['ERROR']
        }
        this.code = ''
        this.loading = false
      }
    }
  }

  async getRegistrationDate(contractNumber) {
    this.loading = true
    this.error = ''
    try {
      const { data } = await api.get(`/loyalty/${contractNumber}/check`)
      this.createdAt = data.registrationDate
      this.loading = false
    } catch (err) {
      console.log(extractError(err))
      this.accountError = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      this.errorTitle = t[extractError(err) + '_TITLE']
      this.error = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
      this.loading = false
      window.scrollTo(0, 0)
    }
  }

  async redeemPoints() {
    try {
      await api
        .post('/loyalty/redeem-points', {
          serialNumber: this.user.loyaltySerialNumber
        })
      this.getLoyaltyProgramViewData(this.user.loyaltySerialNumber)
      this.showThankYou = true
    } catch (err) {
      console.log('redeeming points failed')
      this.cashOutError = extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
    }
  }
}

export default LoyaltyStore
